
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'app/service/user.service';
import { MIN_PASSWORD_LENGTH, translatePasswordErrors } from 'app/validator/password-rules';
import { ConfirmPasswordValidator } from 'app/validator/confirm-password.validator';
import { ToastrService } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent {
  readonly currentYear = new Date().getFullYear();
  changePasswordForm!: FormGroup;
  submitted!: boolean;
  readonly minLength = MIN_PASSWORD_LENGTH;
  password: any;
  new_password: any;
  errormsg: any;
  serverErrors: string[] = [];
  selectedLanguage:any = "en";
  confirmPassword: boolean = false;
  newPassword: boolean = false;
  supportedLanguages: { code: string, name: string }[] = [
    { code: 'de', name: 'Deutsch' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'pt', name: 'Português' }
  ];
  constructor(private http: HttpClient, public _router: Router,
    private userService: UserService,
    private _translate: TranslateService,
    private toastr: ToastrService, private translate: TranslateService, private formBuilder: FormBuilder,) {
      translate.setDefaultLang('en');
      const savedLanguage = localStorage.getItem('selectedLanguage');
      if (savedLanguage) {
        this.selectedLanguage = savedLanguage;
        translate.use(savedLanguage);
      } else {
        translate.use('en');
      }
  }

 
  ngOnInit() {
    this.changePasswordForm = this.formBuilder.group(
      {
        password: [null, [Validators.required, Validators.minLength(MIN_PASSWORD_LENGTH)]],
        new_password: [null, [Validators.required, Validators.minLength(MIN_PASSWORD_LENGTH)]],
      },
      {
        validator: ConfirmPasswordValidator('password', 'new_password'),
      }
    );
    const storedLanguage = localStorage.getItem('selectedLanguage');
    if (storedLanguage) {
      this.selectedLanguage = storedLanguage;
    } else {
      this.selectedLanguage = 'en';
      localStorage.setItem('selectedLanguage', 'en');
    }
    this.translate.use(this.selectedLanguage);
  }

  newPasswordVisibility() {
    this.newPassword = !this.newPassword;
  }

  confirmPasswordVisibility() {
    this.confirmPassword = !this.confirmPassword;
  }

  changeLanguage(lang: string) {
    this.selectedLanguage = lang;
    this.translate.use(lang);
    localStorage.setItem('selectedLanguage', lang);
    this.userService.loadLang.next(lang);
   
  }

  get f(): { [key: string]: AbstractControl } {
    return this.changePasswordForm.controls
  }

  changePassword() {
    this.submitted = true;
    this.serverErrors = [];
    if (this.changePasswordForm.invalid) {
      return;
    }
    const token = this.extractTokenFromURL();
    let data = {
      new_password: this.changePasswordForm.controls['new_password'].value,
      token: token,
    };
    if (this.changePasswordForm.value.password === this.changePasswordForm.value.new_password) {
      this.userService.changePassword(data).subscribe(
        (res) => {
          this._router.navigate(['/login']);
          this.toastr.success(this.translate.instant('authPages.updated'));
        },
        (err) => {
          if (err.status == 409) {
            this.errormsg = 'changePassword.form.error.passwordIsNotNew';
          } else if (err.status == 400 && Array.isArray(err.error?.new_password)) {
            // Passwortregeln des Servers (z. B. zu häufig, zu ähnlich)
            this.serverErrors = translatePasswordErrors(this.translate, err.error.new_password, err.error.new_password_codes);
            this.errormsg = null;
          } else {
            this.errormsg = 'changePassword.form.error.passwordNotMatch';
          }
        }
      );
    }
  }

private extractTokenFromURL(): string | null {
  const url = window.location.href;
  const tokenMatch = url.match(/[?&]token=([^&]+)/);
  return tokenMatch ? decodeURIComponent(tokenMatch[1]) : null;
}

}
